export const DS_CARD_EXPANDED_STORAGE_KEY = "ds_card_expanded";
